import { EIcons } from '@/app/types/iconType'
import { Icon } from '@/shared'
import { APP_LOGO } from '@Config/config'

import { SectionTitle } from '../SectionTitle/SectionTitle'

import style from './AppLogoConfig.module.scss'
import { ImageLoader } from './ImageLoader/ImageLoader'

interface IProps {
    isOpen: boolean
    onSetIsOpen: (isOpen: boolean) => void
    onUploadImageCallback: (file: File) => void
}

export const AppLogoConfig = (props: IProps) => {
    const { isOpen, onSetIsOpen, onUploadImageCallback } = props
    return (
        <div className={style.container}>
            <ImageLoader
                show={isOpen}
                onClose={() => onSetIsOpen(false)}
                onUploadImageCallback={onUploadImageCallback}
                allowedFormats={['jpg', 'jpeg', 'png']}
                currentImage={APP_LOGO}
            />
            <SectionTitle
                header='Логотип Приложения'
                description='Раздел для установки актуального логотипа приложения'
            />
            <div className={style.photo}>
                <div className={style.imgWrapper}>
                    <img
                        src={APP_LOGO}
                        onError={({ currentTarget }) => {
                            currentTarget.onerror = null
                            currentTarget.src =
                                'https://www.meme-arsenal.com/memes/20d600dd79c74b47a39ec029235fa3a1.jpg'
                        }}
                        alt='Изображение не работает'
                    />
                </div>
                <div className={style.btnsWrapper}>
                    <div onClick={() => onSetIsOpen(true)}>
                        <Icon iconName={EIcons.PDVCE} />
                    </div>
                </div>
            </div>
        </div>
    )
}
